import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function tokenFromStorage() {
  return localStorage.getItem("gufi_token");
}

export function setToken(t) {
  if (t) localStorage.setItem("gufi_token", t);
  else localStorage.removeItem("gufi_token");
}

api.interceptors.request.use((cfg) => {
  const t = tokenFromStorage();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function fileUrl(path) {
  if (!path) return null;
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  const t = tokenFromStorage();
  return `${API}/files/${path}${t ? `?auth=${encodeURIComponent(t)}` : ""}`;
}

export function publicFileUrl(path) {
  if (!path) return null;
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  return `${API}/public/files/${path}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Qualcosa è andato storto.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
